import {addErrorClass, addLoadingClass, removeLoadingClass} from "./utilities/updateClasses";
import {initSlidecontents} from "./slidecontent";

function setActiveClassForFilter(btn,wrapper){
    for(let btn of wrapper.querySelectorAll(".js-collectionFilter .tag")){
        btn.classList.remove("is-active");
    }
    btn.classList.add("is-active");
}

function scrollToActiveFilter(filterID = null) {
    const groupFilter = filterID || new URLSearchParams(window.location.search).get('group_filter');

    if (groupFilter) {
        const activeFilter = document.querySelector(`.js-collectionFilter .tag[data-filter="${groupFilter}"]`);

        if (activeFilter) {
            const filterContainer = activeFilter.closest('.js-collectionFilter');

            if (filterContainer && filterContainer.scrollWidth > filterContainer.clientWidth) {
                const containerRect = filterContainer.getBoundingClientRect();
                const activeRect = activeFilter.getBoundingClientRect();

                const scrollLeft = activeFilter.offsetLeft - (containerRect.width / 2) + (activeRect.width / 2);

                filterContainer.scrollTo({
                    left: Math.max(0, scrollLeft),
                    behavior: 'smooth'
                });
            }

            if (!filterID) {
                setActiveClassForFilter(activeFilter, activeFilter.closest('.collection'));
            }
        }
    }
}

function loadPageContent(url, clickedElement, wrapper, area, isFilter = false) {
    const wrapperId = wrapper.getAttribute("id");

    addLoadingClass(clickedElement);
    addLoadingClass(area);

    fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Could not load page data");
            }
            return response.text();
        })
        .then((data) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(data, "text/html");
            let newWrapper = doc.getElementById(wrapperId);
            if (newWrapper) {
                let newArea = newWrapper.querySelector(".collectionArea");
                if (newArea) {
                    area.innerHTML = newArea.innerHTML;
                    removeLoadingClass(clickedElement);
                    removeLoadingClass(area);

                    if (isFilter) {
                        const urlObj = new URL(url, window.location.origin);
                        const filterID = urlObj.searchParams.get('group_filter');

                        const navTag = wrapper.querySelector(`.js-collectionFilter .tag[data-filter="${filterID}"]`);
                        if (navTag) {
                            setActiveClassForFilter(navTag, wrapper);
                        } else {
                            for(let btn of wrapper.querySelectorAll(".js-collectionFilter .tag")){
                                btn.classList.remove("is-active");
                            }
                        }
                        scrollToActiveFilter(filterID);

                        if (!clickedElement.closest('.js-collectionFilter')) {
                            const filterNav = wrapper.querySelector('.js-collectionFilter');
                            if (filterNav) {
                                const elementTop = filterNav.getBoundingClientRect().top + window.scrollY;
                                const offsetPosition = elementTop - 120;

                                window.scrollTo({
                                    top: offsetPosition,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    } else {
                        const elementTop = area.getBoundingClientRect().top + window.scrollY;
                        const offsetPosition = elementTop - 120;

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }

                    initSlidecontents();
                    initContentTagHandlers();
                    initPaginationHandlers();
                    window.history.replaceState(null, null, url);
                } else {
                    console.error('Area not found');
                }
            } else {
                console.error('Wrapper not found');
            }
        })
        .catch((e) => {
            console.error('Error:', e);
            addErrorClass(clickedElement);
            addErrorClass(area);
        });
}

function loadFilterContent(filterID, clickedElement, wrapper, area) {
    loadPageContent("?group_filter=" + filterID, clickedElement, wrapper, area, true);
}

function initContentTagHandlers() {
    for (let tag of document.querySelectorAll(".collectionArea .tag[href*='group_filter'], .collectionArea .tags a[href*='group_filter']")) {
        if (tag.hasAttribute('data-ajax-handled')) continue;
        tag.setAttribute('data-ajax-handled', 'true');

        let wrapper = tag.closest(".collection");
        if (wrapper) {
            let area = wrapper.querySelector(".collectionArea");
            if (area) {
                tag.addEventListener("click", function (e) {
                    e.preventDefault();
                    const url = new URL(tag.href);
                    const filterID = parseInt(url.searchParams.get('group_filter'));
                    loadFilterContent(filterID, tag, wrapper, area);
                });
            }
        }
    }
}

function initPaginationHandlers() {
    for (let link of document.querySelectorAll(".collectionArea .pagination__item")) {
        if (link.hasAttribute('data-ajax-handled')) continue;
        link.setAttribute('data-ajax-handled', 'true');

        let wrapper = link.closest(".collection");
        if (wrapper) {
            let area = wrapper.querySelector(".collectionArea");
            if (area) {
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    loadPageContent(link.href, link, wrapper, area, false);
                });
            }
        }
    }
}

export function initAjaxCollectionFilter(){
    scrollToActiveFilter();
    initContentTagHandlers();
    initPaginationHandlers();
    for(let btn of document.querySelectorAll(".js-collectionFilter .tag")){
        let wrapper = btn.closest(".collection");
        if(wrapper){
            let area = wrapper.querySelector(".collectionArea");
            if(area){
                btn.addEventListener("click",function (e){
                    e.preventDefault();
                    let filterID = parseInt(btn.dataset.filter);
                    loadFilterContent(filterID, btn, wrapper, area);
                });
            }
        }
    }
}